import { useMutation } from '@tanstack/react-query';
import { resendEmailVerification } from '../../api';

export function useResendEmailVerification() {
  return useMutation({
    mutationFn: ({ email }: { email: string }) => resendEmailVerification(email),
  });
}
